import { Mail, Phone, MapPin, Globe } from "lucide-react";
import { COMPANY } from "@/config/site";
import { Reveal } from "./Reveal";

const rows = [
  { key: "address", label: "Registered / Corporate Office", Icon: MapPin, href: null },
  { key: "email", label: "Business Email", Icon: Mail, href: (v) => `mailto:${v}` },
  { key: "phone", label: "Contact Number", Icon: Phone, href: (v) => `tel:${v.replace(/\s/g, "")}` },
  { key: "website", label: "Official Website", Icon: Globe, href: (v) => v },
];

export const ContactSection = () => (
  <dl className="grid border-t hairline sm:grid-cols-2" data-testid="contact-details">
    {rows.map(({ key, label, Icon, href }, i) => {
      const v = COMPANY.contact[key];
      return (
        <Reveal key={key} delay={i * 0.06} className="border-b hairline py-8 sm:odd:pr-8 sm:even:pl-8 sm:even:border-l">
          <dt className="flex items-center gap-3 eyebrow !text-[0.68rem]"><Icon size={15} aria-hidden="true" /> {label}</dt>
          <dd className="mt-4 text-lg" data-testid={`contact-${key}`}>
            {v ? (
              href ? <a href={href(v)} className="link-underline" target={key === "website" ? "_blank" : undefined} rel="noopener noreferrer">{v}</a> : v
            ) : (
              <span className="text-[var(--ink-2)]">To be updated with verified details</span>
            )}
          </dd>
        </Reveal>
      );
    })}
  </dl>
);
